import { render } from "./Edit.vue?vue&type=template&id=3fe86328&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=3fe86328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe86328"],['__file',"src/views/Terms/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fe86328"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fe86328', __exports__)) {
    api.reload('3fe86328', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=3fe86328&scoped=true", () => {
    api.rerender('3fe86328', render)
  })

}


export default __exports__